// import { AccountStateModel } from '../state/account.state';
import { Account } from '../../interfaces';

export class SetCurrentUser {
  static readonly type = '[Account] SetCurrentUser';

  constructor(public payload: Account) {}
}
